"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listSurveys = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _tokenStorage = _interopRequireDefault(require("./lib/tokenStorage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SIXTY_SECONDS = 60000;

var axiosInstance = _axios["default"].create({
  timeout: SIXTY_SECONDS,
  baseURL: process.env.REACT_APP_SURVEY_SERVICE_URL,
  responseType: 'json'
});

axiosInstance.interceptors.request.use(function (request) {
  request.headers.Authorization = _tokenStorage["default"].get();
  return request;
});
axiosInstance.interceptors.response.use(function (response) {
  if (response.data === undefined) return response;
  return response.data;
}, function (error) {
  return Promise.reject(error);
});

var listSurveys = function listSurveys(options) {
  return axiosInstance.get("/survey/list".concat(options.states ? '?states=' + JSON.stringify(options.states) : ''));
};

exports.listSurveys = listSurveys;